import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import EndocrineOestrogenCombined from "./index";

const EndocrineOestrogenWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={EndocrineOestrogenCombined}
    keyControlsId="endocrine-oestrogen-key"
    {...props}
  />
);

export default EndocrineOestrogenWithToggleKey;
